'use strict';
/**
 * Updates the visibility of swatch images based on the available container width.
 * If swatches overflow the container, it hides exceeding ones and updates the '+N' indicator.
 * This is required only for MM6
 *
 * @param {HTMLElement} container - The swatches container element (.js-swatches-color)
 */
function updateSwatches(container) {
    var $container = $(container);
    if (!$container.length) return;

    var $swatches = $container.find('.swatches-color__image');
    var $indicator = $container.find('.swatches-color__more-indicator');
    var totalColors = parseInt($container.data('total'), 10);
    var GAP = 1; // Horizontal gap between swatches in pixels
    var MAX_TOTAL_SLOTS = 5; // Maximum allowed slots (images + indicator)

    // Reset visibility state before recalculating
    $swatches.removeClass('is-hidden');
    $indicator.removeClass('is-show');

    var containerWidth = $container.outerWidth();
    var indicatorWidth = $indicator.outerWidth();

    let currentTotalWidth = 0;
    let visibleCount = 0;

    /**
     * Iterative calculation of how many swatches can fit in the container
     * considering the width of each swatch, the gap, and the space required for the indicator.
     */
    for (let i = 0; i < $swatches.length; i++) {
        var $swatch = $($swatches[i]);
        const swatchWidth = $swatch.outerWidth();
        const swatchTotalWidth = swatchWidth * totalColors;
        let widthToTest = currentTotalWidth + swatchWidth;

        if (i > MAX_TOTAL_SLOTS) break;

        // Check for overflow:
        // 1. If we are not at the last swatch and we need space for the indicator
        if (i < $swatches.length - 1 && swatchTotalWidth > containerWidth) {
            if (widthToTest + GAP + indicatorWidth > containerWidth) break;
        } else if (i < $swatches.length - 1 && swatchTotalWidth <= containerWidth) {
            // 2. If we are not at the last swatch but we need space for the next gap
            if (widthToTest + GAP > containerWidth) break;
        } else {
            // 3. Last swatch check
            if (widthToTest > containerWidth) break;
        }

        // Update cumulative width
        if (i < $swatches.length - 1) {
            currentTotalWidth += swatchWidth + GAP;
        } else {
            currentTotalWidth += swatchWidth;
        }

        visibleCount++;
    }

    if (visibleCount > MAX_TOTAL_SLOTS) {
        visibleCount--;
    }

    $swatches.each(function (index) {
        if (index >= visibleCount) {
            $(this).addClass('is-hidden');
        }
    });

    // Update the '+N' indicator count
    const hiddenCount = totalColors - visibleCount;
    if (hiddenCount > 0) {
        $indicator.text('+' + hiddenCount);
        $indicator.addClass('is-show');
    } else {
        $indicator.removeClass('is-show');
    }
}

/**
 * Handle image swapping logic when hovering a swatch
 */
function handleSwatchHover() {
    $('body').on('mouseenter', '.swatches-color__image', function () {
        var $swatch = $(this);
        if ($swatch.hasClass('selected')) return;

        var $card = $swatch.closest('.mm-product-card, .mm6-product-card');
        var $swatchesContainer = $swatch.closest('.js-swatches-color');

        if ($swatchesContainer.length) {
            $swatchesContainer.addClass('has-hovered-swatch');
        }
        $swatch.addClass('is-hovered');

        var largeImage = $swatch.data('image-large');
        var $mainImage = $card.find('.swiper-slide-active .js-product-card-img');

        if (largeImage && $mainImage.length) {
            // Store original source if not already stored, to allow restoration on leave
            if (!$card.data('originalImageSrc')) {
                $card.data('originalImageSrc', $mainImage.attr('src'));
            }
            $mainImage.attr('src', largeImage);
            // Clear srcset to force usage of the new specific variation image
            if ($mainImage.attr('srcset')) {
                $mainImage.attr('srcset', '');
            }
        }
    }).on('mouseleave', '.swatches-color__image', function () {
        var $swatch = $(this);
        if ($swatch.hasClass('selected')) return;

        var $card = $swatch.closest('.mm-product-card, .mm6-product-card');
        var $swatchesContainer = $swatch.closest('.js-swatches-color');

        $swatch.removeClass('is-hovered');

        if ($swatchesContainer.length && !$swatchesContainer.find('.is-hovered').length) {
            $swatchesContainer.removeClass('has-hovered-swatch');
        }

        var $mainImage = $card.find('.swiper-slide-active .js-product-card-img');

        // Restore original image only if no other swatch is currently hovered
        if (!$card.find('.is-hovered').length && $mainImage.length) {
            var originalSrc = $card.data('originalImageSrc');
            if (originalSrc) {
                $mainImage.attr('src', originalSrc);
                $card.removeData('originalImageSrc');
            }
        }
    });
}

/**
 * Sets up a ResizeObserver on swatch containers
 */
function setupObservers() {
    $('.mm6-product-card__details-swatches-color').each(function () {
        var container = this;
        if (container.dataset.observed) return;

        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.contentRect.width > 0) {
                    window.requestAnimationFrame(() => updateSwatches(container));
                }
            }
        });

        observer.observe(container);
        container.dataset.observed = "true";
    });
}

function openSwatchWithLazyload($target, containerClass) {
    var $card = $target.closest('.js-product-card');

    $card.addClass('is-color-open');
    $card.find(containerClass).addClass('is-color-open');
}

module.exports = {
    initFunction: function () {
        // Handle window resize to recalculate swatches on open cards
        $(window).on('resize', function () {
            $('.is-color-open .mm6-product-card__details-swatches-color, .is-color-open .mm-product-card__details-swatches-color').each(function () {
                var container = this;
                window.requestAnimationFrame(() => updateSwatches(container));
            });
        });

        // Initialize observers for existing cards
        setupObservers();

        // Re-initialize observers when PLP is updated via AJAX
        $('body').on('product:update-plp-cards', function () {
            setupObservers();
        });

        // Initialize swatch hover logic (delegated)
        handleSwatchHover();
    },

    /**
     * Defines the behavior for opening and closing the swatches on MM6 product cards
     */
    openSwatchesMM6: function () {
        $('body').on('click', '.mm6-product-card .js-swatch-trigger', function (e) {
            e.preventDefault();
            openSwatchWithLazyload($(this), '.mm6-product-card__details');
        });

        $('body').on('click', '.mm6-product-card .swatches-color__close', function (e) {
            e.preventDefault();
            var $card = $(this).closest('.mm6-product-card');
            $card.find('.mm6-product-card__details').removeClass('is-color-open');
        });
    },

    /**
     * Defines the behavior for opening and closing the swatches on MM product cards
     */
    openSwatchesMM: function () {
    // Open Swatches
    $('body').on('click', '.mm-product-card .js-swatch-trigger', function (e) {
        e.preventDefault();
        openSwatchWithLazyload($(this), '.mm-product-card__details-swatches');
    });

    // Close swatches
    $('body').on('click', '.mm-product-card .js-swatch-close', function (e) {
        e.preventDefault();
        var $card = $(this).closest('.mm-product-card');

        $card.removeClass('is-color-open');
        $card.find('.mm-product-card__details-swatches').removeClass('is-color-open');
    });
    }
};
